import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <section className="banner-section ">
        <img
          src="/images/about-banner.jpg"
          className="banner-img"
          alt="Banner Image"
        />
        <div className="container">
          <div className="banner-contant">
            <h1>Terms And Conditions</h1>
            <p class="mb-0">
              Welcome to Modular kitchen – Jaipur’s premier destination for
              innovative, stylish, and functional modular kitchens. We are
              passionate about creating kitchens that go beyond the ordinary,
              combining cutting-edge designs with high-quality materials to
              build spaces where functionality meets elegance.
            </p>
          </div>
        </div>
      </section>
      <section className="seoText">
        <div className="container">
          <p>
            Welcome to Modular Kitchen Jaipur! By accessing or using our website
            (https://modularkitchenjaipur.com), you agree to comply with and be
            bound by the following Terms and Conditions. Please read them
            carefully before using our services.
          </p>

          <h3>1.Acceptance of Terms</h3>
          <p>
            By using our website, you acknowledge that you have read,
            understood, and agree to these Terms and Conditions. If you do not
            agree, please refrain from using our site.
          </p>

          <h3>2.Services</h3>
          <p>
            Modular Kitchen Jaipur provides information and services related to
            modular kitchen designs, products, and installations. All
            descriptions, pricing, and services are subject to change without
            prior notice.
          </p>
          <h3>3. Intellectual Property</h3>
          <p>
            All content on this website, including text, images, logos, and
            designs, is the intellectual property of Modular Kitchen Jaipur.
            Unauthorized reproduction, distribution, or use of our content is
            strictly prohibited.
          </p>
          <h3>4.User Obligations</h3>
          <p>When using our website, you agree to:</p>
          <p>
            Provide accurate and complete information if required. Refrain from
            engaging in any unlawful or harmful activities. Not attempt to
            access or disrupt our website’s security systems or services.
          </p>
          <h3>Limitation of Liability</h3>
          <p>Modular Kitchen Jaipur is not responsible for:</p>
          <p>
            Any direct, indirect, or consequential damages arising from the use
            or inability to use our website.
          </p>
          <p>Errors, inaccuracies, or omissions in the content.</p>
          <p>
            Links to third-party websites, which are provided for convenience
            and do not signify endorsement.
          </p>
          <h3>6. Privacy</h3>
          <p>
            Your use of our website is also governed by our Privacy Policy,
            which outlines how we collect and handle your personal information.
          </p>
          <h3>7. Modifications to Terms</h3>
          <p>
            We reserve the right to update these Terms and Conditions at any
            time. Changes will be effective immediately upon posting on this
            page. Continued use of the website constitutes your acceptance of
            the revised terms.
          </p>
          <h3>8. Governing Law</h3>
          <p>These Terms and Conditions are governed by and construed in accordance with the laws of [Your State/Country]. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in [Your Location].</p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
